import React from 'react'
import { Progress } from "@/components/ui/progress"

const Loader = ({ progress, message }) => {
  return (
    <div className='flex flex-col min-h-screen justify-center items-center gap-4'>
      <Progress value={progress} className="w-[60%]"/>
      <p className="text-gray-600 text-lg">{message || "Loading..."}</p>
    </div>
  )
}

export default Loader